import _o2sService from './_o2sServices';
import { IFilter } from '../models/filters/filter';

import { IManufactoringProductionFilter } from '../models/filters/manufactoringProductionFilter';
import { IManufactoringProductionForm } from '../models/forms/manufactoringProductionForm';
import { IManufactoringProductionPDTO } from '../models/dtos/manufactoringProductionPDTO';
import { API_CENTRE } from './config';

export default class ManufactoringProductionServices extends _o2sService {
    protected static override mainUrl: string = API_CENTRE + '/api/v1/ManufactoringProduction';
    protected static override getUrlFilter<F extends IManufactoringProductionFilter>(filter?: F): string {
        ;
        let url = super.getUrlFilter(filter as IFilter);
        if (filter != null) {
            if (filter.productionId != null)
                url += '&ProductionId=' + filter.productionId;
            if (filter.centerId != null)
                url += '&CenterId=' + filter.centerId;
            if ( filter.loadProduction != undefined)
                url += '&LoadProduction=' + filter.loadProduction;
        }
        return url;
    }

    public static override toDTO(dic: IManufactoringProductionForm): IManufactoringProductionPDTO {
        const dto = super.toDTO(dic) as IManufactoringProductionPDTO;
        return dto;
    }

}
